export enum MearchantSourceType {
    detailsArrow = 'details_arrow',
    detailCard = 'detail_card',
    detailTaber = 'detail_taber',
    // 推荐商品单列-商铺入口-点击
    detailList = 'detail_list',
    detailRecommendMore = 'detail_recommend_more',
    kwaiShopRecommendList = 'KwaiShop_recommend_list',
    myOderList = 'my_oder_list',
    profileCard = 'profile_card',
    orderDetail = 'order_detail',
    merchantInfo = 'merchant_info',

    // RN
    RNorderDetailMerchantInfo = 'rn_order_detail_merchant_info',
    RNmyShoppingCarShopCardHeader = 'rn_my_shopping_car_shopcard_header',
    RNmyShoppingCarShopCardCoupon = 'rn_my_shopping_car_shopcard_coupon',
    RNOptionBar = 'rn_option_bar',
    RNMerchanLine = 'rn_merchant_line',
    RNOrderDetailRefundProgressList = 'rn_order_detail_refund_progress_list',

    // 小黄车顶部标题
    RNShoppingCarHeader = 'rn_shopping_car_header',

    RNDetailCouponClickUse = 'rn_detail_use_coupon',
    RNDetailCouponHalfPageClickUse = 'rn_detail_half_coupon_page_use_coupon',
}
